<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3">
<h2 class="titlepage">Ancient Battle Formations</h2>
<p class="titlepage1">Justin Swanton</p>
<div class="img_container">
<img alt="image" src="images/Img_3-001.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?c8fa1df2